import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Hero from '../Components/Hero/Hero'
import Popular from '../Components/Popular/Popular'
import Offers from '../Components/Offers/Offers'
import NewCollections from '../Components/NewCollections/NewCollections'
import NewsLetter from '../Components/NewsLetter/NewsLetter'
import data_product from '../Components/Assets/data'
import new_collections from '../Components/Assets/new_collections'

const Shop = () => {

  const [popular, setPopular] = useState([]);
  const [newcollection, setNewCollection] = useState([]);

  const fetchInfo = () => { 
    axios.get('https://shopper-e-commerce-project-xi55.vercel.app/popularinwomen')
      .then((res) => setPopular(res.data.length > 0 ? res.data : data_product))
      .catch(() => setPopular(data_product));
    axios.get('https://shopper-e-commerce-project-xi55.vercel.app/newcollections')
      .then((res) => setNewCollection(res.data.length > 0 ? res.data : new_collections))
      .catch(() => setNewCollection(new_collections));
  }

    useEffect(() => {
      fetchInfo();
    }, [])


  return (
    <div>
      <Hero/>
      <Popular data={popular}/>
      <Offers/>
      <NewCollections data={newcollection}/>
      <NewsLetter/>
    </div>
  )
}

export default Shop
